import type { ChatMessageData } from "../types";
import type { SiteConfig } from "../site-config";
import { ChatAvatar } from "./ChatAvatar";
import { UserIcon } from "./Icons";

interface ChatMessageProps {
  message: ChatMessageData;
  demoMode: boolean;
  showDemoNotice?: boolean;
  siteConfig: SiteConfig;
}

export function ChatMessage({ message, demoMode, showDemoNotice = false, siteConfig }: ChatMessageProps) {
  const isAssistant = message.role === "assistant";
  const isDemoFollowUp =
    demoMode && isAssistant && message.questionKind === "followup";

  return (
    <div className={`message-row ${isAssistant ? "assistant" : "user"}`}>
      {isAssistant ? (
        <ChatAvatar chatAvatarUrl={siteConfig.chatAvatarUrl} />
      ) : null}
      <div className="message-content">
        <div className={`message-bubble${isDemoFollowUp ? " demo-followup-bubble" : ""}`}>
          {isDemoFollowUp ? (
            <span className="demo-followup-label">追加質問</span>
          ) : null}
          {isDemoFollowUp && showDemoNotice ? (
            <span className="demo-followup-note" role="note">
              デモ版では追加質問をオレンジの吹き出しで表示しています。
            </span>
          ) : null}
          <span>{message.content}</span>
        </div>
      </div>
      {!isAssistant ? (
        <div className="avatar user-avatar" aria-hidden="true">
          <UserIcon />
        </div>
      ) : null}
    </div>
  );
}
